export enum KlarnaStatus {
  NOT_OK = 'KLARNA_STATUS_NOT_OK',
  OK = 'KLARNA_STATUS_OK',
  COMPLETED = 'KLARNA_STATUS_COMPLETED',
}
